import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import FrontInvestModuleTypes from '@/store/modules/frontDesk/invest/interface';

const frontInvestModule: Module<FrontInvestModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        listDeveloperName(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listDeveloperName", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listJoinCategory(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listJoinCategory", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        pageProjectList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/pageProjectList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        pageActivityList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/pageActivityList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivityListByInvest(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listActivityListByInvest", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getActivity(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/getActivity", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivityImage(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listActivityImage", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getActivityApply(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/getActivityApply", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveActivityApply(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/saveActivityApply", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        sumInvestCount(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/sumInvestCount", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivityProvince(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listActivityProvince", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivityBrand(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listActivityBrand", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listDecorateType(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listDecorateType", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listHouseNature(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listHouseNature", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listLastQuarterBetween(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/frontend/activity/anon/listLastQuarterBetween", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
      },
        
      listTimeSearchTypes(context) {
        return new Promise((resolve, reject) => {
          tool.post("/frontend/index/anon/listTimeSearchTypes", {}).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },

      deleteActivityApply(context, searchParams) {
          return new Promise((resolve, reject) => {
              tool.post("/frontend/activity/deleteActivityApply", searchParams).then(data => {
                  if (data.status === 2000) {
                      resolve(data);
                  }
                  else {
                      reject(data);
                  }
              });
          });
      },

      listSeason(context) {
        return new Promise((resolve, reject) => {
          tool.post("/frontend/index/anon/listSeason", {}).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
      },
        
      pageSumBySeasonStat(context, searchParams) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/index/anon/pageSumBySeasonStat", searchParams).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
    },
    checkIsApply(context, searchParams) {
        return new Promise((resolve, reject) => {
            tool.post("/frontend/index/anon/checkIsApply", searchParams).then(data => {
                if (data.status === 2000) {
                    resolve(data);
                }
                else {
                    reject(data);
                }
            });
        });
    },
  },
    

};

export default frontInvestModule;